import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";

/** QTAP_ADMINS only — Timetable admin. */
export default function SuperAdminRoute({ children }) {
  const { user } = useAuth();

  return (
    <ProtectedRoute>
      {user === null ? null : !user?.can_access_timetable_admin ? (
        <Navigate to="/timetable" replace />
      ) : (
        children
      )}
    </ProtectedRoute>
  );
}
